<template>
  <div class="d-flex flex-column align-items-center cluster-master">
    <h2>Cluster Master Controller</h2>
    <div class="dropdown">
      <label class="col-form-label" for="durationOptions"
        >Override Scheduler</label
      >
      <div class="custom-select">
        <select
          id="Device-Type"
          class="btn dropdown-toggle"
          v-model="durationOpt"
          :disabled="editTimer"
        >
          <option value="" disabled>Select duration</option>
          <option
            v-for="option in durationOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
    <!-- <span v-if="!showCountDown" style="color: green">{{ msg }}</span> -->
    <vue-countdown
      v-if="showCountDown"
      :time="duration * 1000"
      class="override-countdown mt-2"
      @end="reresetScheduler()"
      v-slot="{ minutes, seconds }"
    >
      Override Countdown {{ minutes < 10 ? "0" + minutes : minutes }}:{{
        seconds < 10 ? "0" + seconds : seconds
      }}
    </vue-countdown>

    <div class="mt-2 mb-3">
      <label class="col-form-label mb-0" for="CurrentBrightness"
        >Current Brightness
      </label>
      <h1>{{ brightness }}%</h1>
      <!-- width="290px" -->
      <VueSlider
        :dot-style="{
          backgroundColor: editMode ? '#9B9A9A' : '#218863',
          border: 'none',
        }"
        :rail-style="{
          borderRadius: '21px',
          backgroundColor: '#D9D9D9',
        }"
        :process-style="{
          backgroundColor: '#2BAD7E',
        }"
        :tooltip-style="{
          width: '24px',
          backgroundColor: '#D9D9D9',
          borderColor: '#D9D9D9',
          color: '#218863',
          fontFamily: 'Inter',
          fontSize: '12px',
          fontWeight: '400',
          textAlign: 'center',
          padding: '0',
        }"
        :dot-size="24"
        v-model="brightness"
        :width="'100%'"
        height="8px"
        class="mt-4"
        :data="slider"
        :marks="false"
        :tooltip="'always'"
        :tooltip-placement="'top'"
        :disabled="editScheduler"
      ></VueSlider>
    </div>
    <div class="mb-3">
      <button
        v-if="showTurnOn"
        class="btn btn-green"
        type="button"
        :disabled="editScheduler"
        @click="handleTurnOn"
      >
        Turn On
      </button>
      <button
        v-else
        class="btn btn-yellow"
        type="button"
        @click="handleTurnOff"
      >
        Turn Off
      </button>
    </div>
  </div>
</template>
<script>
import VueCountdown from "@chenfengyuan/vue-countdown";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import moment from "moment";

export default {
  components: {
    VueSlider,
    VueCountdown,
  },
  props: {
    selectedDuration: {
      type: [Number, String, null],
      required: true,
    },
    isOverride: {
      type: Boolean,
    },
    timerLeft: {
      type: [Number, String],
      required: true,
    },
  },
  // ["durationSelected", "timerLeft"],
  emits: ["onStop", "onClick", "onChangeScheduler"],
  data() {
    return {
      editTimer: false,
      lockCount: 0,
      showTurnOn: true,
      durationOptions: [
        {
          label: "1 Minute",
          value: 60,
        },
        {
          label: "30 Minute",
          value: 1800,
        },
        {
          label: "60 Minute",
          value: 3600,
        },
      ],
      durationOpt: this.selectedDuration,
      duration: 0,
      useMock: false,
      brightness: 10,
      slider: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      isFirstLoad: true,
      showCountDown: false,
      editScheduler: true,
      msg: "",
      timerFlag: "",
    };
  },
  mounted() {
    // get current brightness and on off status
    this.getCurrentBrightnessAndOnOffStatus();
  },
  watch: {
    selectedDuration(newVal) {
      this.durationOpt = newVal;
    },
    durationOpt(val) {
      if (!Number(val) || val === 0) {
        return;
      }
      this.duration = val;
      this.$emit("on-change-scheduler", val);
    },
    timerLeft() {
      let timeEnd = moment(this.timerLeft, "YYYY-MM-DD HH:mm:ss");
      let now = moment();

      let diffInSeconds = 0;
      if (this.timerLeft != 0) {
        diffInSeconds = timeEnd.diff(now, "seconds");
      } else {
        diffInSeconds = 0;
      }
      this.duration = diffInSeconds;
    },
    brightness(val) {
      // this.editScheduler = true;

      this.showTurnOn = !(Number(val) && val > 0);

      clearTimeout(this.test);

      if (this.lockCount === 0) {
        this.lockCount = 1;
      } else {
        if (this.brightness !== "") {
          clearTimeout(this.test);
          this.test = setTimeout(() => {
            this.sendCommand(this.brightness);
          }, 500);
        }
      }
    },
    showCountdownTimer: {
      handler([isOverride, showCountDown, duration]) {
        console.log({ isOverride, showCountDown, duration });
        if (!isOverride && Number(duration) && duration !== 0) {
          return;
        }

        // showCountDown
        if (this.showCountDown === false) this.editScheduler = true;
        else this.editScheduler = false;

        // duration
        if (Number(duration) && duration !== 0) {
          this.editTimer = true;
          this.timerFlag = "";
          this.showTurnOn = false;
          this.showCountDown = true;
        }

        this.getCurrentBrightnessAndOnOffStatus();
      },
      immediate: true,
    },
  },
  computed: {
    editMode() {
      return this.isFirstLoad && this.duration !== "";
    },
    showCountdownTimer() {
      return [this.isOverride, this.showCountDown, this.duration];
    },
    // currentBrightness() {
    //   return [this.brightness, this.duration, this.showCountDown]
    // }
  },
  methods: {
    getCurrentBrightnessAndOnOffStatus() {
      this.$http
        .get(":11004/api/v1/lights/cluster/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            // hmm
            this.brightness = response.Brightness;
            this.showTurnOn = response.LightStatus == 0 ? true : false;
            this.msg = response.Message;
          }
        });
    },
    sendCommand(br) {
      this.$emit("on-stop", br, true, this.timerFlag);
      // kalau main brightness lampu auto on, so to change button do this
      // this.showTurnOn = false;
      // this.editScheduler = false;
    },
    // setBrightness() {
    //   this.editScheduler = false;
    // },
    reresetScheduler() {
      this.duration = 0;
      this.showCountDown = false;

      this.timerFlag = "timerhabis";
      this.durationOpt = "";
      this.editScheduler = true;
      this.editTimer = false;
      // timer habis check back current brightness and on off status
      setTimeout(async () => {
        this.getCurrentBrightnessAndOnOffStatus();
      }, 1000);
    },
    handleScheduler(option) {
      this.isFirstLoad = false;
      this.$emit("on-change-scheduler", option);
    },
    handleTurnOn() {
      this.$emit("on-click", this.brightness, this.showTurnOn, this.timerFlag);
      this.showTurnOn = false;
    },
    handleTurnOff() {
      this.$emit("on-click", this.brightness, this.showTurnOn, this.timerFlag);
      this.showTurnOn = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-yellow {
  padding: 0;
  width: 99px;
  height: 38px;
  background-color: #fbb500;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  &:hover {
    background-color: #fbb500;
  }
}

.btn-green {
  padding: 0;
  width: 99px;
  height: 38px;
  background-color: #218863;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  &:hover {
    background-color: #218863;
  }

  &:disabled {
    --bs-btn-disabled-bg: #9b9a9a;
    --bs-btn-disabled-color: #ffffff;
    --bs-btn-disabled-border-color: #9b9a9a;
  }
}

.dropdown {
  .dropdown-toggle {
    position: relative;
    // min-width: 306px;
    // width: auto;
    width: 100%; // Make it responsive inside the card
    min-width: unset;
    max-width: 100%;
    padding: 0 20px;
    padding-right: 35px;
    border-radius: 5px;
    border: 1px solid #218863;
    background: #fff !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 2.5em;
    color: #9b9a9a !important;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    &:hover {
      border: 1px solid #218863;
    }

    &::after {
      color: #218863;
      right: 20px;
    }
  }
}

.cluster-master {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 3px 6px 0px rgba(224, 230, 255, 0.3);
  padding: 20px 24px; // Adds space on left/right
  max-width: 400px; // Optional: set a max width
  width: 100%;
  margin: 0 auto;
  height: 100%;

  label {
    color: #ababab;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: center;
    margin: 0 0 9px;
  }

  h1 {
    color: #000;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    margin-top: -8px;
  }

  h2 {
    color: #000;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0 0 2px;
  }

  .override-countdown {
    color: #ff9700;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
</style>
